import { render, staticRenderFns } from "./FeatureCardPartition.vue?vue&type=template&id=10145538&scoped=true&"
import script from "./FeatureCardPartition.vue?vue&type=script&lang=js&"
export * from "./FeatureCardPartition.vue?vue&type=script&lang=js&"
import style0 from "./FeatureCardPartition.vue?vue&type=style&index=0&id=10145538&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10145538",
  null
  
)

export default component.exports